import React from 'react';

const PARTNERS = [
  { name: "Alchamy",                         src: require("../../assets/partners/Alchamy.logo_-1.png") },
  { name: "American Builders Insurance",     src: require("../../assets/partners/American Builders Insurance Company.png") },
  { name: "American National Lloyds",        src: require("../../assets/partners/American National Lloyds Insurance Company.png") },
  { name: "AmTrust Insurance",               src: require("../../assets/partners/AmTrustInsurance.webp") },
  { name: "Annex Risk",                      src: require("../../assets/partners/Annex Risk.png") },
  { name: "AonEdge",                         src: require("../../assets/partners/AonEdge.jpg") },
  { name: "Attune",                          src: require("../../assets/partners/Attune.png") },
  { name: "Bridger",                         src: require("../../assets/partners/Bridger.png") },
  { name: "Bristol West",                    src: require("../../assets/partners/BristolWest.png") },
  { name: "Burns and Wilcox",                src: require("../../assets/partners/Burns and Wilcox.jpg") },
  { name: "Certain Underwriters at LLOYDS",  src: require("../../assets/partners/Certain Underwriters at LLOYDS.png") },
  { name: "Coast National Insurance",        src: require("../../assets/partners/Coast Natl Ins Co.png") },
  { name: "Collectibles Insurance Services", src: require("../../assets/partners/Collectibles Insurance Services (CIS).webp") },
  { name: "Deductible Defender",             src: require("../../assets/partners/DEDUCTIBLE+DEFENDER+LOGO.webp") },
  { name: "Delos",                           src: require("../../assets/partners/Delos.jpg") },
  { name: "Employers",                       src: require("../../assets/partners/Employers.png") },
  { name: "Firemans Fund",                   src: require("../../assets/partners/FIREMANS FUND IND CORP.png") },
  { name: "Sierra Specialty Insurance",      src: require("../../assets/partners/Sierra Specialty Insurance Company.png") },
  { name: "WKFC Property Consortium",        src: require("../../assets/partners/WKFC Property Consortium.png") },
  { name: "Accredited",                      src: require("../../assets/partners/accredited.png") },
  { name: "Aegis",                           src: require("../../assets/partners/aegis.png") },
  { name: "Ahoy",                            src: require("../../assets/partners/ahoy.png") },
  { name: "AM Best",                         src: require("../../assets/partners/am-best.png") },
  { name: "American Modern",                 src: require("../../assets/partners/american-modern.png") },
  { name: "Anthem",                          src: require("../../assets/partners/anthem.png") },
  { name: "Associated Industries",           src: require("../../assets/partners/associated-industries.png") },
  { name: "AU Gold",                         src: require("../../assets/partners/au-gold.png") },
  { name: "Bamboo",                          src: require("../../assets/partners/bamboo.png") },
  { name: "Benchmark Insurance",             src: require("../../assets/partners/benchmark-insurance-company.png") },
  { name: "Berkshire Hathaway Homestate",    src: require("../../assets/partners/berkshire-hathaway-homestate-companies.png") },
  { name: "biBerk",                          src: require("../../assets/partners/biBerk.jpg") },
  { name: "Blitz",                           src: require("../../assets/partners/blitz.png") },
  { name: "Blue California",                 src: require("../../assets/partners/blue-california.png") },
  { name: "Bridge Specialty Group",          src: require("../../assets/partners/bridge-specialty-group.png") },
  { name: "BTIS",                            src: require("../../assets/partners/btis.png") },
  { name: "California Earthquake Authority", src: require("../../assets/partners/california-earthquake-authority.png") },
  { name: "California FAIR Plan",            src: require("../../assets/partners/california-fair-plan-property-insurance.png") },
  { name: "Canopius",                        src: require("../../assets/partners/canopius.png") },
  { name: "Century Insurance Group",         src: require("../../assets/partners/century-insurance-group.png") },
  { name: "CF Fairfax",                      src: require("../../assets/partners/cf-a-fairfax-company.png") },
  { name: "Chubb",                           src: require("../../assets/partners/chubb.png") },
  { name: "Continental Casualty",            src: require("../../assets/partners/continental-casualty.png") },
  { name: "Coterie",                         src: require("../../assets/partners/coterie.png") },
  { name: "Cowbell",                         src: require("../../assets/partners/cowbell.png") },
  { name: "Cypress",                         src: require("../../assets/partners/cypress.png") },
  { name: "ePremium",                        src: require("../../assets/partners/epremium.jpg") },
  { name: "Ergo Next",                       src: require("../../assets/partners/ergo-next.png") },
  { name: "Fetch Pet Insurance",             src: require("../../assets/partners/fetch-pet-insurance.png") },
  { name: "First Insurance",                 src: require("../../assets/partners/first-insurance.png") },
  { name: "Foremost",                        src: require("../../assets/partners/foremost-real.png") },
  { name: "Fortegra",                        src: require("../../assets/partners/fortegra.png") },
  { name: "Foxquilt",                        src: require("../../assets/partners/foxquilt.png") },
  { name: "GeoVera",                         src: require("../../assets/partners/geovera.png") },
  { name: "Great American",                  src: require("../../assets/partners/great-american.png") },
  { name: "GuideOne Insurance",              src: require("../../assets/partners/guideone-insurance.png") },
  { name: "Hadron",                          src: require("../../assets/partners/hadron.png") },
  { name: "Hagerty",                         src: require("../../assets/partners/hagerty.png") },
  { name: "Harborway Insurance",             src: require("../../assets/partners/harborway-insurance.png") },
  { name: "Hiscox",                          src: require("../../assets/partners/hiscox.png") },
  { name: "Homesite",                        src: require("../../assets/partners/homesite.png") },
  { name: "Hudson",                          src: require("../../assets/partners/hudson.png") },
  { name: "IDIQ",                            src: require("../../assets/partners/idiq.png") },
  { name: "Insur-Fi",                        src: require("../../assets/partners/insur-fi.png") },
  { name: "ISC",                             src: require("../../assets/partners/isc.png") },
  { name: "Jewelers Mutual",                 src: require("../../assets/partners/jewelers-mutual.png") },
  { name: "Kaiser Permanente",               src: require("../../assets/partners/kaiser-permanente.png") },
  { name: "Kanguro",                         src: require("../../assets/partners/kanguro.png") },
  { name: "Kelly Klee",                      src: require("../../assets/partners/kelly-klee.png") },
  { name: "Kemper",                          src: require("../../assets/partners/kemper.png") },
  { name: "King Embark",                     src: require("../../assets/partners/king-embark.png") },
  { name: "Kinsale",                         src: require("../../assets/partners/kinsale.png") },
  { name: "Knight Insurance Group",          src: require("../../assets/partners/knight-insurance-group.png") },
  { name: "KW Specialty Insurance",          src: require("../../assets/partners/kw-specialty-insurance-company.png") },
  { name: "Lightspeed Specialty",            src: require("../../assets/partners/lightspeed-specialty-insurance-solutions.png") },
  { name: "Lio",                             src: require("../../assets/partners/lio.png") },
  { name: "Markel",                          src: require("../../assets/partners/markel.png") },
  { name: "Merchants Bonding",               src: require("../../assets/partners/merchants-bonding-company.png") },
  { name: "MGT",                             src: require("../../assets/partners/mgt.png") },
  { name: "Millennium Insurance",            src: require("../../assets/partners/millennium-insurance-corporation.png") },
  { name: "Monoline",                        src: require("../../assets/partners/monoline.png") },
  { name: "Mount Vernon",                    src: require("../../assets/partners/mount-vernon.png") },
  { name: "MSI",                             src: require("../../assets/partners/msi.png") },
  { name: "National General",                src: require("../../assets/partners/national-general.png") },
  { name: "National Liability and Fire",     src: require("../../assets/partners/national-liability-and-fire.png") },
  { name: "Nationwide",                      src: require("../../assets/partners/nationwide.png") },
  { name: "Navigators / The Hartford",       src: require("../../assets/partners/navigators-brand-of-the-hartford.png") },
  { name: "Neptune Flood",                   src: require("../../assets/partners/neptune-flood.png") },
  { name: "NSI Insurance Group",             src: require("../../assets/partners/nsi-insurance-group.png") },
  { name: "Obie",                            src: require("../../assets/partners/obie-2.png") },
  { name: "Obie Classic",                    src: require("../../assets/partners/obie.png") },
  { name: "Pacific Specialty",               src: require("../../assets/partners/pacific-specialty.png") },
  { name: "Pathpoint",                       src: require("../../assets/partners/pathpoint.png") },
  { name: "Pie Insurance",                   src: require("../../assets/partners/pie-insurance.png") },
  { name: "Progressive Commercial",          src: require("../../assets/partners/progressive-commercial.png") },
  { name: "Propeller",                       src: require("../../assets/partners/propeller.png") },
  { name: "Rainbow",                         src: require("../../assets/partners/rainbow.png") },
  { name: "RLI",                             src: require("../../assets/partners/rli.png") },
  { name: "Rockingham Insurance",            src: require("../../assets/partners/rockingham-insurance.png") },
  { name: "Ryan Specialty",                  src: require("../../assets/partners/ryan-specialty.png") },
  { name: "Sayata",                          src: require("../../assets/partners/sayata.png") },
  { name: "Seaview Insurance",               src: require("../../assets/partners/seaview-insurance-company.png") },
  { name: "Selective",                       src: require("../../assets/partners/selective.png") },
  { name: "Semsee",                          src: require("../../assets/partners/semsee.png") },
  { name: "SES Risk Solutions",              src: require("../../assets/partners/ses-risk-solutions.png") },
  { name: "Simply Business",                 src: require("../../assets/partners/simply-business.png") },
  { name: "SiriusPoint",                     src: require("../../assets/partners/siriuspoint.png") },
  { name: "Skywatch",                        src: require("../../assets/partners/skywatch.png") },
  { name: "Slice",                           src: require("../../assets/partners/slice.png") },
  { name: "S. Phillips Surety",              src: require("../../assets/partners/sphilips-surety-insurance-services-inc.png") },
  { name: "Spinnaker Insurance",             src: require("../../assets/partners/spinnaker-insurance-company.png") },
  { name: "State Fund",                      src: require("../../assets/partners/state-fund.png") },
  { name: "State National",                  src: require("../../assets/partners/state-national.png") },
  { name: "Steadily",                        src: require("../../assets/partners/steadily.png") },
  { name: "Sterling Surplus Underwriters",   src: require("../../assets/partners/sterling-surplus-underwriters.png") },
  { name: "Superior Flood",                  src: require("../../assets/partners/superior-flood-inc.png") },
  { name: "Sutton National",                 src: require("../../assets/partners/sutton-national.png") },
  { name: "Tend",                            src: require("../../assets/partners/tend.png") },
  { name: "The Hartford",                    src: require("../../assets/partners/the-hartford.png") },
  { name: "Thimble",                         src: require("../../assets/partners/thimble.png") },
  { name: "Three",                           src: require("../../assets/partners/three.png") },
  { name: "Tower Hill Insurance",            src: require("../../assets/partners/tower-hill-insurance.png") },
  { name: "Travelers",                       src: require("../../assets/partners/travelers.png") },
  { name: "Trisura",                         src: require("../../assets/partners/trisura.png") },
  { name: "UCS Surety Solution",             src: require("../../assets/partners/ucs-your-surety-solution.png") },
  { name: "Vacant Express",                  src: require("../../assets/partners/vacant-express.png") },
  { name: "Wellfleet",                       src: require("../../assets/partners/wellfleet.png") },
  { name: "Wesco Insurance Agency",          src: require("../../assets/partners/wesco-insurance-agency.png") },
  { name: "Westchester",                     src: require("../../assets/partners/westchester.png") },
  { name: "Wright Flood",                    src: require("../../assets/partners/wright-flood.png") },
];

// Balanced arrays (~58 elements each) so velocity calculates equally
const halfIndex = Math.ceil(PARTNERS.length / 2);
const ROW_1 = PARTNERS.slice(0, halfIndex);
const ROW_2 = PARTNERS.slice(halfIndex);

function MarqueeRow({ logos, reverse = false }) {
  const items = [...logos, ...logos];
  return (
    <div className="overflow-hidden relative py-2">
      {/* Soft Vignette Overlay Blurs */}
      <div
        className="absolute inset-y-0 left-0 w-36 z-10 pointer-events-none"
        style={{ background: "linear-gradient(to right, #F7F4EF 20%, transparent)" }}
      />
      <div
        className="absolute inset-y-0 right-0 w-36 z-10 pointer-events-none"
        style={{ background: "linear-gradient(to left, #F7F4EF 20%, transparent)" }}
      />
      
      <div
        className={reverse ? "marquee-right" : "marquee-left"}
        style={{ display: "flex", width: "max-content", gap: "24px" }}
      >
        {items.map((p, i) => (
          <div
            key={i}
            className="flex-shrink-0 w-48 h-24 bg-white-pure rounded-xl border border-blue-dark/5 shadow-sm flex items-center justify-center p-5 transition-all duration-300 hover:shadow-md hover:border-blue-dark/20 group select-none"
          >
            <img
              src={p.src}
              alt={p.name}
              title={p.name}
              className="max-h-full max-w-full object-contain filter grayscale opacity-70 contrast-125 transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PartnershipsSection() {
  return (
    <section className="w-full py-28 overflow-hidden" style={{ backgroundColor: "#F7F4EF" }}>
      <style>{`
        @keyframes scroll-left {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
        @keyframes scroll-right {
          from { transform: translateX(-50%); }
          to   { transform: translateX(0); }
        }
        /* Drastically improved duration paths for elegant pacing */
        .marquee-left  { animation: scroll-left  160s linear infinite; }
        .marquee-right { animation: scroll-right 150s linear infinite; }
        .marquee-left:hover,
        .marquee-right:hover { animation-play-state: paused; }
      `}</style>

      {/* Section header */}
      <div className="max-w-5xl mx-auto px-6 mb-16 text-center">
        <div className="flex flex-col items-center gap-5">
          <div className="flex items-center gap-3">
            <span
              className="font-cinzel text-blue-dark uppercase tracking-widest font-medium"
              style={{ fontSize: "11px", letterSpacing: "0.25em" }}
            >
              — Partnerships —
            </span>
          </div>

          <h2
            className="font-cinzel font-bold text-blue-dark uppercase"
            style={{ fontSize: "clamp(26px, 4vw, 42px)", letterSpacing: "0.04em", lineHeight: "1.2" }}
          >
            Our Trusted Partner Carriers
          </h2>

          <div className="flex items-center gap-4">
            <div className="h-px w-16 bg-blue-dark opacity-20" />
            <div className="w-1 h-1 rotate-45 bg-blue-dark opacity-40" />
            <div className="h-px w-16 bg-blue-dark opacity-20" />
          </div>

          <p
            className="font-constantia text-black-deep max-w-2xl leading-relaxed"
            style={{ fontSize: "16.5px", opacity: 0.7 }}
          >
            We partner with 100+ top-rated carriers across every coverage line — giving you more
            choices, better rates, and coverage tailored to your exact needs. Hover over a logo to pause.
          </p>
        </div>
      </div>

      {/* Marquee rows */}
      <div className="space-y-6">
        <MarqueeRow logos={ROW_1} />
        <MarqueeRow logos={ROW_2} reverse />
      </div>
    </section>
  );
}